import React from "react";
import { Webcam } from "../../types";
// import { WebcamMarkerIcon } from "../icons";
import styles from "./WebcamsList.module.css";

interface WebcamsListProps {
  webcams: Webcam[];
  onWebcamSelect: (webcam: Webcam) => void;
}

export const WebcamsList: React.FC<WebcamsListProps> = ({
  webcams,
  onWebcamSelect,
}) => {
  const handleWebcamClick = (webcam: Webcam) => {
    onWebcamSelect(webcam);
  };

  if (webcams.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.stickyHeader}>
          <h3 className={styles.title}>Камеры</h3>
        </div>
        <div className={styles.emptyState}>
          <h3 className={styles.emptyTitle}>Камеры недоступны</h3>
          <p className={styles.emptySubtitle}>
            В данном городе нет доступных веб-камер
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.stickyHeader}>
        <h3 className={styles.title}>Камеры</h3>
      </div>

      <div className={styles.webcamsList}>
        {webcams.map((webcam, index) => (
          <div key={webcam.id}>
            <button
              className={styles.webcamItem}
              onClick={() => handleWebcamClick(webcam)}
            >
              {/* <div className={styles.webcamIcon}>
                <WebcamMarkerIcon />
              </div> */}
              <span className={styles.webcamName}>{webcam.name}</span>
              <svg
                className={styles.arrowIcon}
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            {index < webcams.length - 1 && <div className={styles.separator} />}
          </div>
        ))}
      </div>
    </div>
  );
};
